export const bestClasses = [
  {
    slug: "top-10-best-art-classes-london",
    title: "Top 10 Best Art Classes in London",
    image: {
      href:
        "https://res.cloudinary.com/obby/image/upload/v1642504443/Page%20Images/best-classes/art/header-art.jpg",
      desc: "art-image-header"
    },
    excerpt:
      "From drawing, painting and sculpting to creating graffiti street art like Banksy! Get messy and creative with the best art classes in London. Interested in intricate art? Explore calligraphy, life drawing and fine art classes in London. Learn how to make your own artwork like a true artist!",
    metaDescription:
      "Discover the best local art classes in London! From painting, drawing, sculpting and calligraphy to stained glass and welding art classes in London.",
    intro:
      "We can all feel intimidated by a blank canvas! With these art classes in London, you will never be short of inspiration. Whether you want to appreciate the art of life drawing or create oil landscape paintings like Bob Ross, learn from creative artists within art workshops in London. Work with watercolours, mosaic tiles or clay to make your own wall art and abstract ornaments. Craft your own pop of art with printmaking art courses in London! We have listed the top ten best art classes in London, which will take you from feeling like a beginner to professional artist.",
    postIntro: "Top 10 Best Art Classes in London:",
    conclusion:
      "Many artists use art as a form of creative therapy. Artists that appreciate and practice art regularly find that being creative and present is a very powerful way to explore mindfulness and mediation. However, some artists appreciate art for its energising nature. Whether you find learning new art skills calming or stimulating, art classes in London will help you get creative in a way that suits you! From virtual sketching and illustration classes to in studio stained glass workshops, find the artist within you with the best art classes in London.",
    blogLinks: [
      {
        href:
          "https://obby.co.uk/blog/top-8-best-welding-courses-classes-and-workshops-in-london/",
        desc: "Top 8 Best Welding Courses, Classes and Workshops in London"
      },
      {
        href: "https://obby.co.uk/blog/pottery-classes-east-london",
        desc: "Top 10 Best Pottery Classes in East London"
      },
      {
        href: "https://obby.co.uk/blog/obbys-top-classes-weekend/",
        desc: "10 of the Best Classes to do at the Weekend"
      },
      {
        href:
          "https://obby.co.uk/blog/top-10-best-sewing-courses-classes-workshops-in-london/",
        desc: "Top 10 Best Sewing Courses, Classes and Workshops In London"
      },
      {
        href: "https://obby.co.uk/blog/jewellery-making-courses-london-obby/",
        desc: "Top 10 Best Jewellery Making Classes In London"
      }
    ],
    classes: [
      {
        title: "Various Techniques Mosaics Course with London School of Mosaic",
        content: [
          "Whether you’re a beginner or an experienced mosaic enthusiast, learn something new and refine your skills in this ten week course. Discover different techniques and practise making creative pieces! Work on your own individual project with your own personal design. You will be able to make a mosaic choosing from one of the following techniques: direct, indirect, double indirect (into plastercine) or direct into tile adhesive. Learn how to cut and shape material with tile nippers, how to form a curve and how to use a hammer and hardie to cut down stone and marble. You will be able to explore the expressive possibilities of mosaic in your use of ‘andamento’ which is the different ways of laying down your mosaic tesserae to create different effects.",
          "London School of Mosaic is a small independent art school specialising in mosaic art. They have over 14 years of experience in teaching mosaic art and offer a vast range of unique short courses to suit students of all levels."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/hrmxxvgyboomwjdeckvq/various-techniques-mosaic-course-1531477633.jpg",
          desc: "school-of-mosaic"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/various-techniques-mosaic-course-1531477633",
          desc: ""
        }
      },
      {
        title:
          "Introductory Welding Course For Artists with London Sculpture Workshop",
        content: [
          "This three hour long welding class will absolutely fly by but the knowledge you learn will stay with you forever! Get extremely hands-on experience learning how to work with scrap metal from a professional.",
          "Learn the basics of mig and arc welding which are essential skills for if you want to develop your ability to work with metal. Metal welding techniques can be used with various materials as well as when making all sorts of art. It's a practical and beneficial skill for any avid sculpture artist! You are not only taught this exciting skill, but also the essential safety information which you will practice all throughout your welding career.",
          "London Sculpture Workshop is an independent sculpture studio offering exceptional facilities for artists and those interested in making three-dimensional work. Their short courses cover a wide variety of technical and skill-based processes, taught by practising artists in superbly equipped workshops."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/lquwz4kiznmtm7qujjvn/introductory-welding-for-artists-woolwich-south-east-london.jpg",
          desc: "sculpture-workshop"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/welding/introductory-welding-for-artists-woolwich-south-east-london",
          desc: ""
        }
      },
      {
        title: "Five Week Throwing Course with Sak Beh Pottery",
        content: [
          "Fill your Sunday evenings with wheel throwing classes! If you’re a beginner and want your own potter’s wheel to practise on with the guidance of a professional teacher, then this workshop is for you! Leave this course with five ceramic pieces as well as your new found wheel throwing know-how. With a mixture of hands-on learning and demonstrations, learn how to centre, open and pull up the walls of your pot. Spin, decorate, glaze and finish your pot! In this course you will learn all the tips and tricks of making your own pottery from scratch.",
          "Sak Beh Studio Pottery creates a comfortable place to work and be creative, the studio is a drop of calm in a very fast moving world. Sak Beh Pottery is envisaged as a place for community interaction within the context of a creative journey."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/hzx43w5ppnikbydqda5r/five-week-throwing-course-1557999886.jpg",
          desc: "sak-beh-pottery"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/five-week-throwing-course-1557999886",
          desc: ""
        }
      },
      {
        title: "Brush Pen Calligraphy for Beginners",
        content: [
          "Dr. Sai Banerjee is an experienced teaching artist, art historian and calligrapher committed to promoting creativity as a wellness practice through art and calligraphy. Sai is the founder of Blue Palette Art Studio – a creative space that nurtures mindful creativity through classes, courses and workshops for adults and children.",
          "Whether it's doodling in an art journal or practicing calligraphy, mindfulness is an important part of Sai's creative practice. Her approach to teaching is gentle and optimistic, focusing on the process rather than the outcome. Her main aim as a teacher is to demystify the complexities of learning a new skill and provide her students with the knowledge and confidence they need to pursue their newfound interests."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/mchmcwghlhklocja14ep/brush-pen-calligraphy-for-beginners-1637414272.jpg",
          desc: "pen-caligraphy"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/calligraphy/brush-pen-calligraphy-for-beginners-1637414272",
          desc: ""
        }
      },
      {
        title: "Coached: Studio Painting Experience.",
        content: [
          "Discover your inner creative with Dragon's Den success, Masterpeace. Run by a team of 20 artists, the studio based in Belgravia, London offers a range of different art classes. Like the name suggests, MasterPeace are less focused on the finished product, and more on how the artistic process can be an avenue for meditation and mindfulness.",
          "Out of the many worthy classes to choose from, Obby recommends the Coached: Studio Painting Experience.  In this relaxed session you will be guided by a professional artist and create your own unique acrylic painting. With the added bonus of a free cocktail and sweet treat, what's not to love!"
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/d3hulxgtnnnaszopkeqx/mindful-painting-masters-in-portraiture-1570646403.jpg",
          desc: "painting-experience"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/painting/mindful-painting-masters-in-portraiture-1570646403",
          desc: ""
        }
      },
      {
        title: "Artistic Oil Painting Class",
        content: [
          "This is an Artistic drop-in painting class in London that doesn't require the commitment to a course. The classes were started by Alan Storer who felt that London needed a casual, accessible painting course led by a professional artist.",
          "Allan has a genuine passion for teaching and is keen to pass on his skills to students, which is what makes his classes so enjoyable and instructive. Alan accommodates everyone, whether you're a complete beginner, or a slightly more experienced painter who's interested in receiving further professional guidance."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/ovck5kb9iuxaw8gqvrhn/introduction-to-oil-painting-1519682408.jpg",
          desc: "painting-class"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/painting/introduction-to-oil-painting-1519682408",
          desc: ""
        }
      },
      {
        title: "Introduction to Watercolour Painting",
        content: [
          "Step inside Alma Tipon's private studio to explore the process of painting. Alma will share the techniques she applies to paint using watercolour and a touch of gouache. You will join a cosy atmosphere, soothing music, surrounded by her paintings, candles, fairy lights and a touch of tropical vibes with lots of tea and coffee. This masterclass is for students of any ability wanting to boost their confidence and watercolour painting techniques. There will be plenty of time for painting exercises and practise before you make your main masterpiece.",
          "Alma Tipon is an artist based in London. She is currently an art instructor and runs her own art business where she gets inspiration from sharing her passion for painting and art with students of all levels."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/uxeptybwhsp3qfvalpls/painting-workshop-at-the-artist-studio-1636405164.jpg",
          desc: "watercolour-painting"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/painting/painting-workshop-at-the-artist-studio-1636405164",
          desc: ""
        }
      },
      {
        title: "Modern Calligraphy For Beginners with London Calligraphy",
        content: [
          "This calligraphy class from Katie, founder of London Calligraphy (who has worked with some of the worlds most exclusive brands including Chanel, Royal Ascot, Vogue and Buckingham Palace), is perfect if you're looking for a way to disconnect and get back to a tactile skill: writing. In this class, you'll have 2 hours of calligraphy instruction where you'll learn essential techniques and how to use a dip pen and ink, practice the basic strokes and the alphabet, before developing your own style. Along with this tutoring, you'll also receive your own personalised modern calligraphy kit to take home, including a penholder and nib, ink, paper and other stationery treats!"
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/mt9axhlt4fa2auqmnxcz/modern-calligraphy-for-beginners-1504189212.jpg",
          desc: "london-calligraphy"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/calligraphy/modern-calligraphy-for-beginners-1504189212",
          desc: ""
        }
      },
      {
        title: "Paint in an Artist's Studio at a City Farm",
        content: [
          "On arrival, Georgie will set you up with a canvas and begin with some mindfulness, art or literature linked to the month's theme to get you feeling inspired. You can then go for a walk around the farm to salvage materials for texture, or just soak up the nature, before getting stuck into your piece. She will talk you through the process of building up your composition, helping you shed your inner perfectionist so you can focus on enjoying the process! With unlimited teas and coffees, this class is another great activity to try with friends or family"
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/p2dnznpbfjm17eeeijql/paint-with-georgie-saturdays-1538752714.jpg",
          desc: "city-farm"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/painting/paint-with-georgie-saturdays-1538752714",
          desc: ""
        }
      },
      {
        title: "Pottery Wheel Throwing Class",
        content: [
          "This studio workshop is based in Bow, which is slightly hidden from London city, making it the ideal place to relax and enjoy working with the most therapeutic material in the world.",
          "This 2 and a half hour pottery class is designed to help students discover the possibilities of clay. Let your creativity take the wheel in this beginner workshop!",
          "Down to Earth with KC is run by Ka Ching and her fellow course mate Neil. They are two people who are passionate about clay as a creative material and enjoy teaching students how to exercise their creativity with clay."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/pzxnwnlbvm8etsxusmig/pottery-throwing-class-1628935762.jpg",
          desc: "pottery-wheel-class"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/pottery-throwing-class-1628935762",
          desc: ""
        }
      }
    ]
  },
  {
    slug: "top-10-best-pottery-classes-london",
    title: "Top 10 Best Pottery Classes in London",
    image: {
      href:
        "https://res.cloudinary.com/obby/image/upload/v1642524024/Page%20Images/best-classes/pottery/header-pottery.jpg",
      desc: "pottery-image-header"
    },
    excerpt:
      "Sculpt, mould and glaze your own personal pottery ornaments! Create handmade ceramics which are customised with your own design and shape. Have a spin on the potter’s wheel and learn how to create flower pots, dinner sets, vases and so much more. It’s time to get creative with clay!",
    metaDescription:
      "Explore the best pottery classes in London. Stoneware, vases, ornaments and plant pots are just some of the amazing ceramics you will learn how to make.",
    intro:
      "Want to create pottery with your own two hands? Discover how to sculpt clay into wall art, ornaments or plant pots. With pottery classes in London, you will learn from a professional potter who has wealth of experience slabbing, coiling, pinching, sculpting and moulding clay into stunning ceramics. Learn about the whole pottery making process from hand building and wheel throwing to glazing and firing ceramics. We have sculpted a list of the top 10 best pottery classes in London which will awaken your appreciation for clay!",
    postIntro: "Top 10 Best Pottery Classes in London:",
    conclusion:
      "Leave your mark with pottery classes in London! Learn how to add imprints, marks and texture to clay with the guidance of an expert ceramicist. This tactile skill can be used to make a number of beautiful pieces, from practical dinner sets to aesthetic ornaments and wall art. Whether you want to make pottery that looks homemade and unique or smooth and professional looking ceramics, pottery classes in London will help you reach your pottery goals.",
    blogLinks: [
      {
        href: "https://obby.co.uk/blog/pottery-classes-east-london/",
        desc: "Top 10 Best Pottery Classes in East London"
      },
      {
        href: "https://obby.co.uk/blog/pottery-classes-south-west-london/",
        desc: "Top 10 Best Pottery Classes In South London"
      },
      {
        href:
          "https://obby.co.uk/blog/top-8-best-upholstery-courses-in-london/",
        desc: "Top 8 Best Upholstery Courses In London"
      },
      {
        href:
          "https://obby.co.uk/blog/top-8-best-welding-courses-classes-and-workshops-in-london/",
        desc: "Top 8 Best Welding Courses, Classes and Workshops In London"
      },
      {
        href:
          "https://obby.co.uk/blog/top-10-best-sewing-courses-classes-workshops-in-london/",
        desc: "Top 10 Best Sewing Courses, Classes & Workshops In London"
      }
    ],
    classes: [
      {
        title: "Wheel Throwing Workshop",
        content: [
          "In this family friendly class, you and your child will focus on different wheel throwing clay techniques. All children under 16 need to be accompanied by an adult, together you will master wheel throwing! You'll both be guided through various elements of wheel spinning with help all the way through the class.",
          "Each class is carefully designed to allow for children to engage and develop skills whatever their ability. It is a great opportunity to develop creativity and bond through a shared experience together in a stimulating environment."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/wfumg9dwyehhxalj4lrv/sunday-wheel-throwing-workshop-1597428634.jpg",
          desc: "wheel-throwing workshop"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/sunday-wheel-throwing-workshop-1597428634",
          desc: ""
        }
      },
      {
        title: "Hand Building and Wheel Throwing Class",
        content: [
          "You are welcome to play and experiment as much as you like in this three-hour session and indulge in some clay fun! This workshop is perfect for children to come along with their parent or guardian to create something unique and handmade that is truly personal.",
          "During the workshops you will be introduced to a variety of hand-building techniques such as pinching, coiling, slabbing as well as exciting wheel throwing skills."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/cvwbrbyngb0ap6jje20y/ceramic-workshop---wembley-alperton-north-london-1550530211.jpg",
          desc: "hand-building"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/ceramic-workshop---wembley-alperton-north-london-1550530211",
          desc: ""
        }
      },
      {
        title: "Pottery Taster Workshop",
        content: [
          "Get creative, relax and find your inner peace through the art of throwing on the wheel in this taster workshop. Learn hand building skills using coils and slabs then, of course, pottery wheel throwing techniques.",
          "Tutors will go over the basic steps to help you transform a piece of clay into a piece of art within this 3 hour long class. Your work will be Biscuit fired then glazed, you can collect your finished product two weeks after the class."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/gi4mw7094vuewnc4pcp2/pottery-taster-workshop-1502395930.jpg",
          desc: "pottery-taster"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/pottery-taster-workshop-1502395930",
          desc: ""
        }
      },
      {
        title: "Make Your Own Breakfast Bowl",
        content: [
          "Perfect for complete beginners to pick it up and have a go or for anyone wanting a little more practice or help with a new technique. Your teacher will demonstrate each of the stages and you'll spend the workshop building, sculpting and smoothing a breakfast bowl that you can use in your own home.",
          "At the end of the workshop, you'll be able to choose one of the studio glazes for your bowl. The clay and glazes used are strong and durable, so your finished pieces can be used just like everything else in your kitchen and are dishwasher and microwave friendly."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/fcw5srjzgkzah5yxmif6/make-your-own-breakfast-bowl-1524839190.jpg",
          desc: "make-your-own-breakfast-bowl"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/make-your-own-breakfast-bowl-1524839190",
          desc: ""
        }
      },
      {
        title: "Make Ceramic Plant Hangers",
        content: [
          "In this 4 hour long workshop you will make 2 plant holders for succulents in red terracotta clay. Learn how to make one free-standing and one hanging pot which will be fired and ready to pick up later with a selection of plants and hanging material also available. Explore pinch-pot methods and surface decoration techniques as well as how to stamp impressions and add additions of moulded or cut clay shapes."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/rai15u6c0se0ycs3qpm0/make-ceramic-hanging-plant-holders-1520187123.jpg",
          desc: "make-ceramic-plant-hangers"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/make-ceramic-hanging-plant-holders-1520187123",
          desc: ""
        }
      },
      {
        title: "Intensive Wheel Throwing Workshop",
        content: [
          "On this throwing workshop, you will learn a little about the properties of clay and the importance of wedging. You will also learn how to centre, open and pull up the walls of your pot. This is an opportunity to experience studio life and practice in a comfortable learning space. There will be a maximum of seven people on this class and each person will have their own dedicated wheel for the entire length of the workshop."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/vdizot9w6k48tpvdjgyv/taster-throwing-on-the-wheel-session-1547829044.jpg",
          desc: "intensive-wheel-throwing-workshop"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/taster-throwing-on-the-wheel-session-1547829044",
          desc: ""
        }
      },
      {
        title:
          "An Introduction to Ceramics - Hand Building and Surface Decoration",
        content: [
          "This hands-on weekend course will introduce you to the versatility of clay, from making functional items like tableware to conceptual sculpture artwork. You will be fully supported in making objects of your choice through group demonstrations and one-to-one guidance, in a fun and friendly environment, from tutors who are specialist ceramics graduates from the Royal College of Art.",
          "This course is ideal for a beginner who would like to experience and explore the main ways of making ceramics through pinching, coiling, slab building and slip decoration."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/v8emjftamng4mwi34a3n/an-introduction-to-ceramics-handbuilding-and-surface-decoration-diy-sculpting.jpg",
          desc: "introduction-ceramics"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/an-introduction-to-ceramics-handbuilding-and-surface-decoration-diy-sculpting",
          desc: ""
        }
      },
      {
        title: "Sculpt a Plant Pot Workshop",
        content: [
          "The Ceramicists is a highly skilled ceramic studio run by Stephanie and Kevin from Central Saint Martins and the Royal College of Arts. Since 2014 , they have been working on unique projects with Architects, designers, artists, galleries and restaurants. Their versatile workshops can take your experience further. This plant pots and vases workshop with The Ceramicists is one of the best pottery classes in south London. In 4 hours you are guaranteed to be going home with well made and decorated pottery."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/isrovactahingi8ay3fo/ceramic-plant-pots-workshop-1574269942.jpg",
          desc: "sculpt-plant-pot"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/ceramic-plant-pots-workshop-1574269942",
          desc: ""
        }
      },
      {
        title: "Weeknight Ceramics Course",
        content: [
          "This four week course (two hours per session) is for people who want to learn the possibilities of clay. Each two hour evening class will be spent learning varieties of hand building techniques as well as surface decorations and ways to interpret ideas into three dimensional forms.",
          "Martha from Studio1 ceramics has 13 years of ceramics experience, including a masters degree in it. She is also currently researching for a PhD based on figurative sculpture in contemporary art."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/fgwewjs9gcfkxivflp61/monday-ceramics-1518787118.jpg",
          desc: "weeknight-ceramics-course"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/monday-ceramics-1518787118#booking-options",
          desc: ""
        }
      },
      {
        title: "Pottery Taster Session",
        content: [
          "Ronaldo Wiltshire is a London based ceramic artist and Lecturer at Morley North Kensington College. During this 2 hour workshop session, you will be introduced to throwing on the potter’s wheel, you will also have the option to explore various hand building techniques such as coiling, pinching and slab building. Whether you are on the start of your journey or returning after a long break, this session will give you the skills needed to make your own personalised pottery."
        ],
        image: {
          href:
            "https://res.cloudinary.com/obby/images/ylt7qrfujhq40wiixgsp/taster-session-1560110781.jpg",
          desc: "pottery-wheel-class"
        },
        link: {
          href:
            "https://obby.co.uk/classes/art/pottery-and-mosaics/taster-session-1560110781",
          desc: ""
        }
      }
    ]
  }
];

// {_id: {
// 			type: String,
// 			required: true,
// 			default: function() {
// 				return randomID();
// 			}
// 		},
// 		title: {
// 			type: String,
// 			required: true
// 		},
// 		excerpt: {
// 			type: String,
// 			required: true
// 		},
// 		slug: {
// 			type: String,
// 			unique: true,
// 			required: true,
// 			default: function() {
// 				if (this.title) return createSlug(this.title);
// 				else return null;
// 			}
// 		},
// 		content: {
// 			type: String,
// 			required: true
// 		},
// 		image: {
// 			url: {
// 				type: String
// 			},
// 			alt: {
// 				type: String
// 			},
// 			title: {
// 				type: String
// 			}
// 		}}
